import { Logo } from "./Logo";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
};

const links = [
  { id: "gepek", label: "Gépek" },
  { id: "galeria", label: "Galéria" },
  { id: "referenciak", label: "Referenciák" },
];

export const Navbar = () => (
  <nav
    data-testid="main-navbar"
    className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#faf8f5]/80 border-b border-[var(--line)]"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
      <button
        data-testid="nav-logo"
        onClick={() => scrollTo("hero")}
        className="flex items-center gap-2.5"
      >
        <Logo className="h-11 w-auto" />
        <span className="font-serif-d font-semibold text-xl md:text-2xl tracking-tight">
          PILATES&nbsp;FACTORY<span className="text-[var(--terra)]">.</span>
        </span>
      </button>
      <div className="hidden md:flex items-center gap-8">
        {links.map((l) => (
          <button
            key={l.id}
            data-testid={`nav-link-${l.id}`}
            onClick={() => scrollTo(l.id)}
            className="eyebrow text-[var(--ink-soft)] hover:text-[var(--terra)] transition-colors"
          >
            {l.label}
          </button>
        ))}
      </div>
      <button
        data-testid="nav-calculator-btn"
        onClick={() => scrollTo("kalkulator")}
        className="btn-terra rounded-full px-5 py-2 text-sm font-semibold"
      >
        Árkalkulátor
      </button>
    </div>
  </nav>
);
